import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import httpService from "../../services/httpService";
import { notify } from "../utils/methods/notification";
import { fetchAllCountry } from "./country";

const initialState = {
    isLoading: false,
    allCountries: [],
    addModal: false,

};
export const fetchAllState = createAsyncThunk(
    'bmr/fetchAllState',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await httpService.get('/getAllStates', { params: payload });
            return response;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
export const addState = createAsyncThunk(
    'bmr/addState',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const response = await httpService.post('/addstate', args);
            notify.success(response?.data?.message || response?.message || "State added successfully");
            dispatch(disableAddModal());
            dispatch(fetchAllState());
            return response.data;
        } catch (error) {
             notify.error(error || "Something went wrong");
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
export const deleteState = createAsyncThunk(
    'bmr/deleteState',
    async (args, { rejectWithValue }) => {
        try {
            const { id } = args;
            const response = await httpService.delete(`/deleteStates/${id}`);
            notify.success(response?.data?.message || "State deleted successfully");
            return response.data;
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Something went wrong";
            notify.error(message);
            return rejectWithValue(message);
        }
    }
);

export const updateState = createAsyncThunk(
    'state/updateState',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { editId, data } = args;
            const response = await httpService.put(`/updateStates/${editId}`, data);
            notify.success(response?.data?.message || response?.message || "State updated successfully");
                dispatch(disableAddModal());
            dispatch(fetchAllState());
            return response.data;
        } catch (error) {
            notify.error(error || "Something went wrong");
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
const bmrStateSlice = createSlice({
    name: 'bmrState',
    initialState,
    reducers: {
        enableAddModal(state) {
            state.addModal = true
        },
        disableAddModal(state) {
            state.addModal = false
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllState.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAllState.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allStates=action.payload
            })
            .addCase(fetchAllState.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(deleteState.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteState.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(deleteState.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(fetchAllCountry.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAllCountry.fulfilled, (state,action) => {
                state.isLoading = false;
                 state.allCountries = action.payload?.data?? [];
            })
            .addCase(fetchAllCountry.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(updateState.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateState.fulfilled, (state, action) => {
                state.isLoading = false;
                if (state.currentState?.id === action.payload.id) {
                    state.currentState = action.payload;
                }
            })
            .addCase(updateState.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(addState.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(addState.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(addState.rejected, (state) => {
                state.isLoading = false;
            })
    }
})
export const { enableAddModal, disableAddModal } = bmrStateSlice.actions;
export default bmrStateSlice.reducer;